module.exports = __webpack_public_path__ + "assets/754914c3e553d22c2c8b3ab101fbd33c.json";